var map = {
	"./alfabank.svg": "a608",
	"./alipay.svg": "0afd",
	"./applepay.svg": "d76b",
	"./beeline.svg": "4552",
	"./bitcoin.svg": "e9fe",
	"./blockedcash.svg": "49a8",
	"./boleto.svg": "1295",
	"./card.svg": "e8d6",
	"./ecopayz.svg": "5c4f",
	"./ethereum.svg": "b698",
	"./googlepay.svg": "dbd2",
	"./jeton.svg": "c1b7",
	"./kassa24.svg": "ce80",
	"./link.svg": "85d3",
	"./megafon.svg": "af7e",
	"./mts.svg": "7dc1",
	"./oxxo.svg": "31e8",
	"./pagofacil.svg": "b0f0",
	"./promsviaz.svg": "b6ee",
	"./qiwi.svg": "4135",
	"./rapipago.svg": "e83a",
	"./sberbank.svg": "a87e",
	"./skinpay.svg": "a3bc",
	"./skinsback.svg": "19c7",
	"./steam.svg": "6ea1",
	"./tele2.svg": "827b",
	"./tether.svg": "e84c",
	"./tinkoff.svg": "7605",
	"./wechat.svg": "1da2",
	"./yoomoney.svg": "910b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4c7f";